export const GoogleMapApiConfig = 'AIzaSyDZUQ_Xs4ErX2_7k_dT1iTxTMtaqAzdc4E';